import SectionHeader from '@mnd-frontend/ui/public/components/wrappers/SectionHeader';
import { MEDIA_SMALL, SPACING_2, SPACING_6 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import type { LogosFragment } from '../../../../wp-generated/types';
const Container = styled.section<{ $withoutBackgroundImage?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ $withoutBackgroundImage }) => $withoutBackgroundImage && '#181646'}; // fallback - @todo: use token
  color: #ffffff;
  padding: ${SPACING_6} var(--site-padding);
  position: relative;
  width: 100%;
  @media (max-width: ${MEDIA_SMALL}px) {
    padding: 1.5rem var(--site-padding);
  }
`;

const LogoGrid = styled.div`
  display: grid;
  gap: ${SPACING_2};
  grid-template-columns: repeat(auto-fit, minmax(50px, 150px));
  justify-content: center;
  justify-items: center;
  width: 100%;
`;

const Logo = styled.img`
  max-width: 100%;
  height: 100%;
  max-height: 3.75rem;
  filter: invert(100%) brightness(200%);
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`;

const LogosWallModule = ({ moduleData }: { moduleData: LogosFragment }) => {
  const backgroundImage = moduleData?.backgroundImage?.node?.mediaItemUrl;
  return (
    <Container $withoutBackgroundImage={!backgroundImage}>
      <SectionHeader headline={moduleData.title} isSmallFont />
      <LogoGrid>
        {moduleData.images?.nodes.map(logo => {
          return (
            logo.mediaItemUrl && (
              <Logo key={logo.id} src={logo.mediaItemUrl} alt={logo?.altText || ''} />
            )
          );
        })}
      </LogoGrid>
      {backgroundImage && (
        <BackgroundImage
          src={backgroundImage}
          alt={moduleData?.backgroundImage?.node?.altText ?? ''}
        />
      )}
    </Container>
  );
};

export default LogosWallModule;
